export function bootstrap() {
  document.querySelectorAll('.c-vfigure__button').forEach(btn => {
    btn.addEventListener('click', e => {
      btn.parentNode.classList.toggle('c-vfigure--toFront');
    });
  });
}
